import { ArrowRight, MessageCircle } from "lucide-react";
import { BUSINESS } from "@/data/cybernet";

export const Hero = () => {
  const waHref = `https://wa.me/${BUSINESS.primaryWhatsapp}?text=${encodeURIComponent(
    "Hola CYBERNET, quiero información sobre sus servicios."
  )}`;

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative bg-white pt-16 pb-20 md:pt-24 md:pb-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="h-[2px] w-8 bg-[#E10600]" />
              <span className="uppercase text-xs font-bold tracking-[0.25em] text-[#E10600]">
                {BUSINESS.years} años en Cortazar
              </span>
            </div>
            <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter text-[#0A0A0A]">
              Tecnología, trámites
              <br />
              <span className="text-[#E10600]">y papelería</span> en un
              solo lugar.
            </h1>
            <p className="mt-8 text-base sm:text-lg text-[#52525B] max-w-xl leading-relaxed">
              {BUSINESS.intro} Servicio técnico especializado, venta de consumibles
              y accesorios tecnológicos con la calidad que nos respalda desde{" "}
              {BUSINESS.since}.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <button
                data-testid="hero-services-btn"
                onClick={() => scrollTo("servicios")}
                className="inline-flex items-center justify-center gap-2 bg-[#0A0A0A] text-white text-sm font-semibold px-7 py-4 rounded-sm hover:bg-[#E10600] transition-colors group"
              >
                Conocer servicios
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </button>
              <a
                data-testid="hero-whatsapp-btn"
                href={waHref}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 border-2 border-[#0A0A0A] text-[#0A0A0A] text-sm font-semibold px-7 py-4 rounded-sm hover:bg-[#0A0A0A] hover:text-white transition-colors"
              >
                <MessageCircle className="h-4 w-4" />
                Contactar por WhatsApp
              </a>
            </div>

            <div className="mt-14 grid grid-cols-3 gap-8 max-w-md">
              <div>
                <div className="font-display font-black text-3xl text-[#0A0A0A]">
                  20+
                </div>
                <div className="text-xs uppercase tracking-widest text-[#52525B] mt-1">
                  años
                </div>
              </div>
              <div>
                <div className="font-display font-black text-3xl text-[#0A0A0A]">
                  4
                </div>
                <div className="text-xs uppercase tracking-widest text-[#52525B] mt-1">
                  sucursales
                </div>
              </div>
              <div>
                <div className="font-display font-black text-3xl text-[#E10600]">
                  ∞
                </div>
                <div className="text-xs uppercase tracking-widest text-[#52525B] mt-1">
                  soluciones
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 relative flex items-center justify-center">
            <div className="relative w-full max-w-md">
              <div className="absolute -top-8 -left-6 w-28 h-28 border-2 border-[#E10600] rounded-sm" />
              <div className="absolute -bottom-8 -right-6 w-36 h-36 bg-[#0A0A0A] rounded-sm" />
              <div className="absolute inset-0 bg-[#FAFAFA] rounded-sm" />
              <div className="relative bg-white border border-[#E4E4E7] rounded-sm shadow-2xl px-8 py-16 flex items-center justify-center">
                <img
                  src="/cn-full.png"
                  alt="CYBERNET Cortazar"
                  className="w-full h-auto max-w-[320px]"
                  loading="eager"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
